import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

class Charge extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Charge';
    }
    render() {
    	var {charge, user} = this.props;
    	var price = (Number(charge.amount)/100).toFixed(2);
        return (
							<div className="invoice">
								<header className="clearfix">
									<div className="row">
										<div className="col-sm-6 mt-md">
											<h2 className="h2 mt-none mb-sm text-dark text-weight-bold">CHARGE</h2>

										</div>
										<div className="col-sm-6 text-right mt-md mb-md">
											<address className="ib mr-xlg">
												Hailtrace
												<br/>
												3508 French Park Dr. Suite 11, Edmond, OK 73034 United States
												<br/>
												Phone: +1-855-334-HAIL
												<br/>
												info@hailtrace.com
											</address>
											<div className="ib">
												<img src="assets/images/invoice-logo.png" alt="OKLER Themes" />
											</div>
										</div>
									</div>
								</header>
								<div className="bill-info">
									<div className="row">
										<div className="col-md-6">
											<div className="bill-to">
												<p className="h5 mb-xs text-dark text-weight-semibold">To:</p>
												<address>
													{charge.source.name}
													<br/>
													{charge.source.address_line1}, {charge.source.address_city} {charge.source.address_state} {charge.source.address_zip}
													<br/>
													{charge.source.receipt_data}
												</address>
											</div>
										</div>
										<div className="col-md-6">
											<div className="bill-data text-right">
												<p className="mb-none">
													<span className="text-dark">Charge Date:</span>
													<span className="value">{moment(new Date(charge.source.created)).format('MM/DD/YYYY')}</span>
												</p>
											</div>
										</div>
									</div>
								</div>
							
								<div className="table-responsive">
									<table className="table invoice-items">
										<thead>
											<tr className="h4 text-dark">
												<th id="cell-id"     class="text-weight-semibold">#</th>
												<th id="cell-item"   className="text-weight-semibold">Item</th>
												<th id="cell-desc"   className="text-weight-semibold">Description</th>
												<th id="cell-price"  className="text-center text-weight-semibold">Price</th>
												<th id="cell-qty"    className="text-center text-weight-semibold">Quantity</th>
												<th id="cell-total"  className="text-center text-weight-semibold">Total</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>1</td>
												<td className="text-weight-semibold text-dark">{charge.name}</td>
												<td>{charge.metadata.mapTitle ? charge.metadata.mapTitle : charge.description}</td>
												<td className="text-center">{price}</td>
												<td className="text-center">1</td>
												<td className="text-center">{price}</td>
											</tr>
										</tbody>
									</table>
								</div>
							
								<div className="invoice-summary">
									<div className="row">
										<div className="col-sm-4 col-sm-offset-8">
											<table className="table h5 text-dark">
												<tbody>
													<tr className="b-top-none">
														<td colspan="2">Subtotal</td>
														<td className="text-left">{price}</td>
													</tr>
													<tr>
														<td colspan="2"></td>
														<td className="text-left"></td>
													</tr>
													<tr className="h4">
														<td colspan="2">Grand Total</td>
														<td className="text-left">{price}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
        );
    }
}
var mapStateToProps = ({connection, charge}) => {
	return {
		charge,
		connection
	}
}
export default connect(mapStateToProps)(Charge);



// WEBPACK FOOTER //
// ./src/browser/components/account/charge.js